import React, { Component } from "react"
import moment from "moment"
import "./calendar.scss"

class VennCalendar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dateContext: moment(),
      today: moment(),
      selectedDay: moment().get("date"),
    }
  }

  weekdays = moment.weekdays() //['Sunday','Monday','Tuesday' ...]
  weekdaysShort = moment.weekdaysShort() //['Sun','Mon','Tue' ...]
  months = moment.months()

  year = () => {
    return this.state.dateContext.format("Y")
  }

  month = () => {
    return this.state.dateContext.format("MMMM")
  }

  daysInMonth = () => {
    return this.state.dateContext.daysInMonth()
  }

  currentDate = () => {
    return this.state.dateContext.get("date")
  }

  currentDay = () => {
    return this.state.dateContext.format("D")
  }

  firstDayOfMonth = () => {
    let dateContext = this.state.dateContext
    let firstDay = moment(dateContext).startOf("month").format("d") // days of the week 0..1..5..6..
    return firstDay
  }

  static getDerivedStateFromProps = (props, state) => {
    if (props.dateContext) {
      const dateContext = props.dateContext
      return {
        dateContext: dateContext,
      }
    }
    return null
  }

  countEvents = (day) => {
    if (!day) {
      return null
    }
    let days = this.eventDays().filter((num) => num === day)
    return days.length
  }

  eventDays = () => {
    if (this.props.eventDates.length <= 0) {
      return []
    }

    if (moment.utc(this.props.eventDates[0]).format("MMMM") === this.month()) {
      return this.props.eventDates.map((date) => {
        return moment.utc(date).date()
      })
    } else {
      return []
    }
  }

  monthMenu = () => {
    return (
      <div className="label-month">
        <span className="selected-month">{this.month()}</span>
      </div>
    )
  }

  yearMenu = () => {
    return (
      <div className="label-year">
        <span>{this.year()}</span>
      </div>
    )
  }

  setMonth = (month) => {
    let monthNo = this.months.indexOf(month) // month selected
    let dateContext = Object.assign({}, this.state.dateContext) // clone the date context so state does not get mutated
    dateContext = moment(dateContext).set("month", monthNo) // set the new month
    this.setState(() => {
      return { dateContext: dateContext }
    }, this.props.onCalendarUpdate && this.props.onCalendarUpdate(dateContext))
  }

  nextMonth = () => {
    let dateContext = Object.assign({}, this.state.dateContext)
    dateContext = moment(dateContext).add(1, "month")
    this.setState(() => {
      return { dateContext: dateContext }
    }, this.props.onCalendarUpdate && this.props.onCalendarUpdate(dateContext))
    this.props.onNextMonth && this.props.onNextMonth()
  }
  prevMonth = () => {
    let dateContext = Object.assign({}, this.state.dateContext)
    dateContext = moment(dateContext).subtract(1, "month")
    this.setState(() => {
      return { dateContext: dateContext }
    }, this.props.onCalendarUpdate && this.props.onCalendarUpdate(dateContext))
    this.props.onPrevMonth && this.props.onPrevMonth()
  }

  onDayClick = (e, day) => {
    this.setState(
      {
        selectedDay: day,
      },
      () => {
        let dateContext = Object.assign({}, this.state.dateContext)
        dateContext = this.state.selectedDay
          ? moment(dateContext).date(this.state.selectedDay)
          : moment()

        this.props.onDayClick && this.props.onDayClick(e, dateContext)
      }
    )
  }

  render() {
    let weekdays = this.weekdaysShort.map((day) => {
      return (
        <li key={Math.random() * 100} className="calendar-cell">
          {day}
        </li>
      )
    })

    let blanks = []
    for (let i = 0; i < this.firstDayOfMonth(); i++) {
      blanks.push(
        <li key={i} className="calendar-cell cell-empty">
          {""}
        </li>
      )
    }

    let daysInMonth = []
    for (let day = 1; day <= this.daysInMonth(); day++) {
      let selectedClass = ""
      if (this.props.selectedDay) {
        day === this.props.selectedDay.get("date") &&
        this.month() === this.props.selectedDay.format("MMMM")
          ? (selectedClass += "selected-day ")
          : (selectedClass += "")
      } else {
        if (day === this.state.selectedDay) {
          selectedClass += "selected-day "
        }
      }

      let eventDate = ""
      if (this.eventDays().indexOf(day) > -1) {
        eventDate += "event"
      }

      let className = "calendar-cell day "
      if (
        day.toString() === this.currentDay() &&
        this.state.today.format("MMMM") === this.month()
      ) {
        className += "current-day "
      }

      daysInMonth.push(
        <li
          key={Math.random() * 100}
          className={className + selectedClass + eventDate}
          onClick={(e) => this.onDayClick(e, day)}
        >
          {this.countEvents(day) > 1 && (
            <span className="event-number">{this.countEvents(day)}</span>
          )}
          <span>{day}</span>
        </li>
      )
    }

    let totalSlots = [...blanks, ...daysInMonth]
    let rows = []
    let cells = []
    totalSlots.forEach((row, i) => {
      if (i % 7 !== 0) {
        cells.push(row)
      } else {
        let insertRow = cells.slice()
        rows.push(insertRow)
        cells = []
        cells.push(row)
      }
      if (i === totalSlots.length - 1) {
        let insertRow = cells.slice()
        rows.push(insertRow)
      }
    })

    let rowElements = rows.map((day, i) => {
      return (
        <ul key={i} className="calendar-row">
          {" "}
          {day}
        </ul>
      )
    })

    return (
      <div id="calendar" className="calendar-container">
        <div className="calendar-header">
          <div className="calendar-menu">
            <div className="calendar-row">
              <div className="calendar-menu-cell">
                <span
                  className="glyphicon glyphicon-menu-left icon"
                  onClick={(e) => this.prevMonth()}
                />
              </div>
              <div className="calendar-menu-cell cell-center">
                {this.monthMenu()}
                {this.yearMenu()}
              </div>
              <div className="calendar-menu-cell">
                <span
                  className="glyphicon glyphicon-menu-right icon"
                  onClick={(e) => this.nextMonth()}
                />
              </div>
            </div>
          </div>
          <div className="calendar-weekdays">
            <ul className="calendar-row">{weekdays}</ul>
          </div>
        </div>
        <div className="calendar-body">{rowElements}</div>
      </div>
    )
  }
}

VennCalendar.propTypes = {
  // onNextMonth
  // onDayClick
  // currentMonth
}

export default VennCalendar
